const VUE_APP_API_MANAGE_URL = document.querySelector("html").getAttribute("api_manage_url");

export default VUE_APP_API_MANAGE_URL